import FlexiInputText from "slotworks/graphics/elements/flexi-input-text";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { InputTextEvent } from "../../../graphics/elements/flexi-input-text";

export default class AbstractNumberInputControl extends AbstractControl implements Control {

    protected min: number;
    protected max: number;
    protected input: FlexiInputText;
    protected setupData: boolean = false;

    protected changeFunction: () => void;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.input = layer.getFlexiInputText(assetName);

        this.changeFunction = () => this.onChangeHandler();

        this.input.on(InputTextEvent.BLUR, this.changeFunction);
        this.input.on(InputTextEvent.ENTERKEYDOWN, this.changeFunction);
    }

    public destroy() {
        if (this.input) {
            this.input.off(InputTextEvent.BLUR, this.changeFunction);
            this.input.off(InputTextEvent.ENTERKEYDOWN, this.changeFunction);

            this.input.destroy();
            this.input = null;
        }

        super.destroy();
    }

    public setVisible(visible: boolean) {
        this.input.setVisible(visible);
    }

    public setMinMaxRange(min: number, max: number) {
        if (min === undefined || max === undefined) {
            min = Infinity;
            max = Infinity;
        }

        this.input.setMinMaxRange(min, max);
        this.min = min;
        this.max = max;
    }

    public getValidatedCurrency(): number {
        let value = this.getInputAsNumber();

        value = value * 100;

        const totalStake = this.options.getTotalStake();

        if (value < totalStake) {
            value = totalStake;
        }

        return this.clampToMinMax(value);
    }

    public getValidatedInt(): number {
        let value = this.getInputAsNumber();

        if (!Number.isInteger(value)) {
            value = +value.toFixed(0);
        }

        return this.clampToMinMax(value);
    }

    protected onChangeHandler() {
        //
    }

    private clampToMinMax(value: number) {
        if (value !== undefined) {
            if (value < this.min) {
                value = this.min;
            } else if (value > this.max) {
                value = this.max;
            }
        }

        return value;
    }

    private getInputAsNumber(): number {
        const text = this.input.getText();

        return +parseFloat(text).toFixed(2);
    }
}
